document.addEventListener("DOMContentLoaded", function () {
    const thumbnailsWrapper = document.querySelector('.m-media-gallery__wrapper .m-product-media--slider__thumbnails');

    if (!thumbnailsWrapper) return;

    function checkSlides() {
        const slides = thumbnailsWrapper.querySelectorAll('.swiper-slide');

        if (slides.length <= 1) {
            thumbnailsWrapper.style.display = 'none';
        } else {
            thumbnailsWrapper.style.display = '';
        }
    }

    // Run once
    checkSlides();

    // Watch for dynamic changes (Swiper often updates DOM)
    const observer = new MutationObserver(checkSlides);
    observer.observe(thumbnailsWrapper, {
        childList: true,
        subtree: true
    });
});